export type CardImageProps = {
  topCard: {
    img: string,
    altText?: string
  },
  bottomCard: {
    img: string
    altText?: string
  }
}

export const CardImages = ({ topCard, bottomCard }: CardImageProps) => {
  return (
    <>
      <img
        className="my-c-card-image my-c-card-image-top"
        alt={topCard.altText || 'new card top'}
        src={`${process.env.PUBLIC_URL}/img/${topCard.img}`}
      />
      <img
        className="my-c-card-image my-c-card-image-bottom"
        alt={bottomCard.altText || 'new card bottom'}
        src={`${process.env.PUBLIC_URL}/img/${bottomCard.img}`}
      />
    </>
  )
}
